module.exports = __webpack_public_path__ + "img/injective-small-light.98b44300.svg";